import React, { useState, useEffect } from 'react';
import { Menu, X, Navigation } from 'lucide-react';
import { NAV_LINKS } from '../mock';

export default function Header({ onBookRide, onDriveWithUs }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md shadow-[0_1px_0_0_rgba(15,15,16,0.06)]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2.5 select-none" onClick={(e)=>{e.preventDefault();window.scrollTo({top:0,behavior:'smooth'})}}>
          <span className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] bg-[#0f0f10] text-white text-[10px] font-bold tracking-wider">
            OTW
          </span>
          <span className={`text-[15px] font-semibold tracking-[0.18em] ${scrolled ? 'text-[#0f0f10]' : 'text-white'} transition-colors`}>
            ON THE WAY
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => handleNav(l.href)}
              className={`text-[14px] font-medium ${scrolled ? 'text-[#3a3a3d] hover:text-[#0f0f10]' : 'text-white/85 hover:text-white'} transition-colors`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        {/* Right CTAs */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={onBookRide}
            className={`text-[14px] font-medium ${scrolled ? 'text-[#0f0f10] hover:text-[#FF6A1A]' : 'text-white/90 hover:text-white'} transition-colors px-2`}
          >
            Book a ride
          </button>
          <button
            onClick={onDriveWithUs}
            className="inline-flex items-center gap-1.5 bg-[#FF6A1A] hover:bg-[#ff5a05] text-white text-[14px] font-semibold rounded-full px-4 py-2.5 transition-colors shadow-[0_8px_24px_-12px_rgba(255,106,26,0.7)]"
          >
            Drive with us
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          className={`md:hidden p-2 rounded-md ${scrolled ? 'text-[#0f0f10]' : 'text-white'}`}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t border-black/5 bg-white">
          <div className="px-5 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => handleNav(l.href)}
                className="text-left py-2.5 text-[15px] font-medium text-[#0f0f10]"
              >
                {l.label}
              </button>
            ))}
            <div className="flex gap-2 pt-3">
              <button onClick={() => { setOpen(false); onBookRide(); }} className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#0f0f10] text-white text-[14px] font-semibold rounded-full py-3">
                <Navigation size={16} /> Book a ride
              </button>
              <button onClick={() => { setOpen(false); onDriveWithUs(); }} className="flex-1 inline-flex items-center justify-center gap-1.5 bg-[#FF6A1A] text-white text-[14px] font-semibold rounded-full py-3">
                Drive with us
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
